import { get } from '@bigyouth/base'
import orderBy from 'lodash.orderby'
import { connectMenu } from 'instantsearch.js/es/connectors'

let themesInit = false

const renderMenuSelect = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams, createURL } = renderOptions

  if (isFirstRender) {
    const ul = document.createElement('ul')
    ul.classList.add('ais-Menu-list')
    widgetParams.container.appendChild(ul)
  }

  if (!isFirstRender && !themesInit && widgetParams.attribute === 'themes.name') {
    const urlParams = new URLSearchParams(window.location.search)
    const themeInUrl = urlParams.get('theme')

    if (themeInUrl) {
      refine(decodeURI(themeInUrl))
    }

    themesInit = true
  }

  const listItems = orderBy(items, [(item) => item.label], ['asc'])

  widgetParams.container.querySelector('ul').innerHTML = listItems.map((item) => `
    <li class="ais-Menu-item filters__theme ${listItems.length > 6 ? 'filters__theme--col' : 'w-full'}">
      <a href="${createURL(item.value)}" data-value="${item.value}" class="thematic thematic--bigger thematic--with-count ${item.isRefined ? 'is-active' : ''}">
        ${item.label} <span class="thematic__count">${item.count}</span>
      </a>
    </li>`).join('')

  widgetParams.container.querySelectorAll('a').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault()

      if (!event.currentTarget.classList.contains('is-active')) {
        refine(event.currentTarget.dataset.value)
      }

      if (widgetParams.attribute === 'themes.name' && widgetParams.themesIndex[element.dataset.value].length !== 0) {
        get('[js-training-list-panel][data-panel="subthemes"]').classList.add('is-visible')
      } else {
        get('[js-training-list-panel][data-panel="trainings"]').classList.add('is-visible')
      }

      // case no subthemes
      if (widgetParams.themesIndex[element.dataset.value].length === 0) {
        get('[js-training-list-current-subtheme-wrap]').classList.add('is-hidden')
        get('[js-training-list-back-subthemes-label]').innerHTML = 'Retour aux thèmes'
        get('[data-panel="trainings"] [js-training-list-current-theme]').classList.add('no-margin')
      } else {
        get('[js-training-list-current-subtheme-wrap]').classList.remove('is-hidden')
        get('[js-training-list-back-subthemes-label]').innerHTML = 'Retour aux sous-thèmes'
        get('[data-panel="trainings"] [js-training-list-current-theme]').classList.remove('no-margin')
      }
    })
  })
}

const customMenuSelect = connectMenu(renderMenuSelect)

export default customMenuSelect
